import {
  GetCompanyPositiveFeedbackComponentsQuery,
  GetCompanyPositiveFeedbackComponentsQueryVariables
} from 'graphql.types';
import { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';

import { RewardsTabs } from 'settings/components/RewardsTabs';
import { SettingsTitle } from 'settings/components/SettingsTitle';
import { PositiveFeedbackComponent } from 'settings/Settings.types';
import { CenteredLoadingIndicator } from 'common/alchemyComponents/CenteredLoadingIndicator';
import { getCompanyPositiveFeedbackComponents } from 'settings/graphql/getCompanyPositiveFeedbackComponents';

import { Rewards } from '../Rewards';
import { AreasOfExcellence } from '../AreasOfExcellence';

import * as Styled from './SettingsRewards.styled';
import { SettingsRewardsSubtitle } from './SettingsRewardsSubtitle';

function usePositiveFeedbackComponent() {
  const [
    positiveFeedbackComponent,
    setPositiveFeedbackComponent,
  ] = useState<PositiveFeedbackComponent>();
  const { loading, data } = useQuery<
    GetCompanyPositiveFeedbackComponentsQuery,
    GetCompanyPositiveFeedbackComponentsQueryVariables
  >(getCompanyPositiveFeedbackComponents);

  useEffect(() => {
    if (!loading && data?.company?.positiveFeedbackComponents) {
      setPositiveFeedbackComponent(data.company.positiveFeedbackComponents);
    }
  }, [loading, data]);

  return [positiveFeedbackComponent, setPositiveFeedbackComponent] as const;
}

export function SettingsRewards() {
  const [
    positiveFeedbackComponent,
    setPositiveFeedbackComponent,
  ] = usePositiveFeedbackComponent();

  return (
    <>
      <SettingsTitle>Areas of Excellence or Rewards</SettingsTitle>
      {positiveFeedbackComponent && <SettingsRewardsSubtitle />}

      <Styled.FeedbackComponentContainer>
        <RewardsTabs
          activeTab={positiveFeedbackComponent}
          onTabClick={setPositiveFeedbackComponent}
        />
        {!positiveFeedbackComponent && <CenteredLoadingIndicator />}

        {positiveFeedbackComponent ===
          PositiveFeedbackComponent.AreasOfExcellence && <AreasOfExcellence />}
        {positiveFeedbackComponent === PositiveFeedbackComponent.Rewards && (
          <Rewards />
        )}
      </Styled.FeedbackComponentContainer>
    </>
  );
}
